import React from "react";
var TailUpAndDown = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.34375 1.15625L7.34375 4.15625C7.53125 4.34375 7.53125 4.6875 7.34375 4.875C7.15625 5.0625 6.8125 5.0625 6.625 4.875L4.5 2.71875V14.5C4.5 14.7812 4.25 15 4 15C3.71875 15 3.5 14.7812 3.5 14.5V2.71875L1.34375 4.875C1.15625 5.0625 0.8125 5.0625 0.625 4.875C0.4375 4.6875 0.4375 4.34375 0.625 4.15625L3.625 1.15625C3.8125 0.96875 4.15625 0.96875 4.34375 1.15625ZM15.3438 11.875L12.3438 14.875C12.1562 15.0625 11.8125 15.0625 11.625 14.875L8.625 11.875C8.4375 11.6875 8.4375 11.3438 8.625 11.1562C8.8125 10.9688 9.15625 10.9688 9.34375 11.1562L11.5 13.3125V1.5C11.5 1.25 11.7188 1 12 1C12.25 1 12.5 1.25 12.5 1.5V13.3125L14.625 11.1562C14.8125 10.9688 15.1562 10.9688 15.3438 11.1562C15.5312 11.3438 15.5312 11.6875 15.3438 11.875Z",
  fill: "#1F1F1F"
}));
export default TailUpAndDown;